import React, { useEffect, useState, useRef } from "react"; 
import AOS from "aos";
import "aos/dist/aos.css";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Banner Images
import Banner01 from "./../assets/AyurvedaAssets/images/SVG_KAY/Yoga.png";

// Testimonials
import Testimonial01 from "./../assets/AyurvedaAssets/images/testimonial/testimonial-01.png";
import Testimonial02 from "./../assets/AyurvedaAssets/images/testimonial/testimonial-02.png";
import Testimonial03 from "./../assets/AyurvedaAssets/images/testimonial/testimonial-03.png";

// Clients
import Client01 from "./../assets/AyurvedaAssets/images/client/client-01.png";
import Client02 from "./../assets/AyurvedaAssets/images/client/client-02.png";
import Client03 from "./../assets/AyurvedaAssets/images/client/client-03.png";
import Client04 from "./../assets/AyurvedaAssets/images/client/client-04.png";
import Client05 from "./../assets/AyurvedaAssets/images/client/client-05.png";

// CTA
import CTAImg from "./../assets/AyurvedaAssets/images/single-img-05.png";

// NEW SECTION YOGA SVG
import BeCalmImg from "./../assets/AyurvedaAssets/images/SVG_KAY/be-calm.svg";
import BurnFatImg from "./../assets/AyurvedaAssets/images/SVG_KAY/burn-fat.svg";
import GetStrongerImg from "./../assets/AyurvedaAssets/images/SVG_KAY/get-stronger.svg";
import BecomeFlexibleImg from "./../assets/AyurvedaAssets/images/SVG_KAY/become-flexible.svg";

// REUSABLE COMPONENTS
import ServiceListing from "./Components/ServiceList";
import Pricing from "./Components/Pricing";
import PricingComparision from "./Components/PricingComparision";

export default function USHAKriyaWellness({ AllServicesListing }) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);
  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: true, // whether animation should happen only once
    });
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  const testimonialAvatars = [
    {
      img: Testimonial01,
      name: "Christina lois",
      role: "Chairman and founder",
    },
    { img: Testimonial02, name: "Jessica brown", role: "Founder" },
    { img: Testimonial03, name: "Kate mason", role: "Specialist" },
  ];

  const testimonialTexts = [
    "Absolutely a-m-a-z-i-n-g! I have worked with quite a few themes over the years and i have to say that themetechmount have really nailed this one!",
    "This theme feels like they tried to fit elementor into a pre-existing theme. No elementor theme builder components exist.",
    "Template options can be overridden, but that requires more dev work than expected. I would only recommend this theme if the exact template from the demo will work for you.",
  ];

  const clients = [Client01, Client02, Client03, Client04, Client05];

  const benefitsData = [
    {
      title: "Be Calm",
      text: [
        "Reduce Stress",
        "Improve sleep quality",
        "Master breathing techniques",
      ],
      bgColor: "rgba(173, 216, 230, 0.6)", // light blue
      img: BeCalmImg,
      colorClass: "text-primary",
    },
    {
      title: "Burn Fat",
      text: [
        "Build muscle strength",
        "Enhance joint mobility",
        "Improve balance & stability",
      ],
      bgColor: "rgba(224, 255, 255, 0.6)", // light cyan
      img: BurnFatImg,
      colorClass: "text-success",
    },
    {
      title: "Get Stronger",
      text: [
        "Build muscle strength",
        "Enhance joint mobility",
        "Improve balance & stability",
      ],
      bgColor: "rgba(255, 218, 185, 0.6)", // light peach
      img: GetStrongerImg,
      colorClass: "text-warning",
    },
    {
      title: "Become Flexible",
      text: [
        "Improve Joint pains",
        "Increase muscle flexibility",
        "Relieve stiffness & tightness",
      ],
      bgColor: "rgba(144, 238, 144, 0.6)", // light green
      img: BecomeFlexibleImg,
      colorClass: "text-success",
    },
  ];

  // --- YouTube items (same style as your Blog page) ---
  const youtubeVideos = [
    { id: "dMKKFQmEYzA", title: "बिना दवा स्वस्थ, शतायु आनंदित जीवन, ऊषा क्रिया पार्ट 1 अग्नि", url: "https://www.youtube.com/watch?v=dMKKFQmEYzA" },
    { id: "dG8CLQqY4-I", title: "ऊषा क्रिया पार्ट 2 के साथ संपूर्ण क्रिया परिचय", url: "https://www.youtube.com/watch?v=dG8CLQqY4-I" },
     ];

  return (
    <>
      {/* page-title */}
      <div className="custom-usha-kriya-title prt-page-title-row style2">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-8 col-lg-8">
                <div className="prt-page-title-row-heading">
                  <div className="page-title-heading">
                    <h3>We are here for your care</h3>
                    <h2 className="title">
                      Authentic Ayurvedic Healing & Wellness
                    </h2>
                  </div>
                  <div className="page-title-desc">
                    <p>
                      Rooted in India’s ancient wisdom, Bharat Dhara offers
                      holistic Ayurvedic consultations, Panchakarma detox,
                      rejuvenation therapies, yoga, and lifestyle guidance —
                      helping you restore balance, vitality, and inner peace.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4">
                <img
                  alt="Yoga Icon"
                  src={Banner01}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* page-title end */}

      {/* site-main */}
      <div className="site-main">
        {/* About UshaKriya */}
        <section className="usha-kriya-about-sec container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="text-center">
                <h2>Welcome to Yoga with Bharat Dhara</h2>
                <p>Your Path to Wellness and Success Starts Here</p>
              </div>
              <div className="about-card p-5">
                <div className="row">
                  <div className="col-xl-10 col-lg-10">
                    <h3>About Usha Kriya Wellness</h3>
                    <p>
                      Welcome to USHA Kriya with Prashant Bais, where mindfulness meets
                      movement. I’m Prashant Bais, Usha Kriya Sattayu wellness trainer with a
                      mission to make Ushaa Kriya accessible, enjoyable, and
                      transformative for everyone. With years of experience in
                      wellness and a deep love for yoga, I’ve designed these
                      sessions to help you embrace balance in both body and
                      mind. Whether you're a beginner exploring yoga for the
                      first time or a seasoned practitioner looking to deepen
                      your practice, my sessions are crafted to cater to all
                      levels.
                    </p>
                  </div>
                  <div className="col-xl-2 col-lg-2">
                    <img
                      alt="Yoga Icon"
                      src={Banner01}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* About UshaKriya Ends */}

        <div className="container py-5">
          <h4 className="text-center fw-bold">Discover the Benefits</h4>
          <p className="text-center text-muted mb-5 pb-3">
            Transform your body, mind, and soul with expert-guided yoga to
            elevate your well-being.
          </p>

          <div className="row g-4">
            {benefitsData.map((benefit, idx) => (
              <div key={idx} className="col-md-6 col-lg-3">
                <div
                  className={`card h-100 px-4 pt-4 shadow-sm`}
                  style={{ backgroundColor: benefit.bgColor }}
                >
                  <div className="text-center">
                    <h5 className={`fw-bold ${benefit.colorClass}`}>
                      {benefit.title}
                    </h5>
                    <ul className="list-unstyled mt-3 mb-4">
                      {benefit.text.map((point, i) => (
                        <li key={i}>✓ {point}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="text-center" style={{ marginTop: "auto" }}>
                    <img
                      src={benefit.img}
                      alt={benefit.title}
                      fill={"none"}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* appointment-section */}
        <section className="prt-row appointment-section01 clearfix">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="appointment-mask-wrapper">
                  <div className="appointment-mask-circle">
                    <div className="appointment-mask-image-circle"></div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12">
                {/* featured-content-box */}
                <div className="featured-content-box mt-30">
                  <div className="featured-content">
                    <div className="featured-title">
                      <h3>
                        USHA Kriya – Towards Omkara, Swadhyaya &amp; Sattayu /
                        ओंकार, स्वाध्याय और सततायु की ओर
                      </h3>
                      <p>We are here for your care</p>
                    </div>
                    <div className="featured-desc">
                      <div className="page-title-desc">
                        <p>
                          <b>
                            USHA Kriya – Created and Perfected by Bhai Brahm
                            Prashant
                          </b>
                          , a five-step Panch-Tatva healing practice revealed
                          during the sacred Narmada Parikrama (2020). It unites
                          mantra chanting, rhythmic clapping, acupressure, joint
                          activation, and organ awakening into one powerful
                          daily sadhana. Recognized by saints and masters, USHA
                          Kriya is not only beneficial for humanity but
                          essential for the entire creation — guiding you
                          towards balance, vitality, and a long conscious life.
                        </p>
                      </div>

                      <div className="mt-35">
                        <a
                          className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor ml-20"
                          href="contact-us.html"
                        >
                          Book Your Appointment for Next Healing Step
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* featured-content-box end */}
              </div>
            </div>
          </div>
        </section>
        {/* appointment-section end */}

        {/* 🔴 YouTube Videos Section (mobile horizontal, desktop grid) */}
        <section className="prt-row clearfix" style={{ padding: "40px 0" }}>
          <div className="container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="title mb-0">USHA Kriya Youtube Videos</h2>
              <a
                href="https://www.youtube.com/@Bharatdharacares"
                target="_blank"
                rel="noreferrer"
                className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor d-none d-md-inline-block"
              >
                Watch all videos →
              </a>
            </div>

            {/* mobile: horizontal scroll  |  md+: 3-col grid */}
            <div className="d-md-none" style={{ overflowX: "auto" }}>
              <div
                className="flex gap-4 pb-2"
                style={{ display: "flex", scrollSnapType: "x mandatory" }}
              >
                {youtubeVideos.map((video) => (
                  <a
                    key={video.id}
                    href={video.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white rounded-lg flex-shrink-0 transform hover:scale-95 transition-transform duration-300 snap-center w-[328px]"
                  >
                    <img
                      src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                      alt={video.title}
                      className="rounded-lg mb-2 w-full h-[165px] object-contain"
                    />
                    <div className="font-semibold text-sm text-center line-clamp-2">
                      {video.title}
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* desktop / tablet layout */}
            <div className="row d-none d-md-flex">
              {youtubeVideos.map((video) => (
                <div className="col-md-4 mb-4" key={video.id}>
                  <a
                    href={video.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white rounded-lg d-block h-100 p-0"
                    style={{ transition: "transform .3s" }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(.97)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    <img
                      src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                      alt={video.title}
                      className="rounded-lg mb-3 w-100"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div className="px-2 pb-3">
                      <div className="fw-semibold" style={{ fontSize: "15px" }}>
                        {video.title}
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>

            {/* mobile button */}
            <div className="mt-3 d-md-none text-center">
              <a
                href="https://www.youtube.com/@Bharatdharacares"
                target="_blank"
                rel="noreferrer"
                className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
              >
                Watch all videos →
              </a>
            </div>
          </div>
        </section>

        <ServiceListing AllServicesListing={AllServicesListing} />

        <Pricing />

        <PricingComparision />

        {/* NEWER TESTIMONIAL SECTION */}
        <section className="prt-row testimonials-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="testimonials">
                  <div className="row res-1199-align-center">
                    {/* Avatar Slider */}
                    <div className="col-lg-3 col-md-4">
                      <Slider
                        asNavFor={nav2}
                        ref={slider1}
                        slidesToShow={1}
                        swipeToSlide={true}
                        focusOnSelect={true}
                        vertical={false}
                        arrows={false}
                        infinite={true}
                      >
                        {testimonialAvatars.map((t, idx) => (
                          <div key={idx} className="testimonial-avatar-main">
                            <div className="testimonial-avatar">
                              <div className="testimonial-img">
                                <img
                                  width="180"
                                  height="180"
                                  className="img-fluid"
                                  src={t.img}
                                  alt="testimonial"
                                />
                              </div>
                            </div>
                            <div className="testimonial-caption">
                              <h3>{t.name}</h3>
                              <p>{t.role}</p>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>

                    {/* Text Slider */}
                    <div className="col-lg-9 col-md-8">
                      <Slider
                        asNavFor={nav1}
                        ref={slider2}
                        arrows={false}
                        infinite={true}
                        fade={true}
                        autoplay={true}
                        autoplaySpeed={4000}
                      >
                        {testimonialTexts.map((text, idx) => (
                          <div key={idx} className="testimonials text-center">
                            <div className="testimonial-content">
                              <blockquote className="testimonial-text">
                                {text}
                              </blockquote>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>

                  {/* Clients Section */}
                  <div className="row mt-5">
                    <div className="col-xl-3 col-lg-12"></div>
                    <div className="col-xl-9 col-lg-12">
                      <div className="client-box-main d-flex flex-wrap">
                        {clients.map((c, idx) => (
                          <div key={idx} className="client-box">
                            <div className="client-thumbnail">
                              <a href="#">
                                <img
                                  width="158"
                                  height="31"
                                  className="img-fluid"
                                  src={c}
                                  alt="client"
                                />
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  {/* End Clients */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* NEWER TESTIMONIAL SECTION */}

        {/* cta-section */}
        <section className="prt-row padding_zero-section cta-section03 animation clearfix">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="cta-content text-center">
                  <div className="section-title title-style-center_text">
                    <div className="title-header">
                      <h2 className="cta-title">Need a help</h2>
                      <h3 className="cta-titlepre">
                        Are you facing any problem in your health?
                      </h3>
                    </div>
                    <div className="cta-bnt mt-40 fadeup-amin">
                      <a
                        className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-darkcolor"
                        href="contact-us.html"
                      >
                        Contact us now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="prt_single_image-wrapper cta-img mt-40 res-991-mt-20"
                  data-cursor-tooltip=""
                >
                  <div className="prt_single_image-wrapper">
                    <a href="team-details.html">
                      <img
                        width="1920"
                        height="400"
                        className="img-fluid"
                        src={CTAImg}
                        alt="cta"
                      />
                    </a>
                  </div>
                  <div className="prt-pfbox-overlay">
                    <div className="ctaimg-title">
                      <a href="team-details.html">Meet our Bharat Dhara Privar</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* cta-section end */}
      </div>
      {/* site-main end */}
    </>
  );
}
